module.exports = __webpack_public_path__ + "static/media/radial.3b6bdb8a.svg";